<template>
  <v-card class="pa-6" flat>
    <v-row class="mt-2 mr-2">
      <v-btn
        icon
        class="hidden-xs-only ml-3"
        color="primary"
        @click="$router.push('/dashboard')"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <p class="text-h5 bold ml-4">ATIVIDADES</p>
      <v-spacer />
      <v-dialog
        v-model="dialog"
        :max-width="$vuetify.breakpoint.mdAndDown ? '' : '40vw'"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="bold"
            color="secondary"
            large
            rounded
            v-bind="attrs"
            v-on="on"
            @click="dialog = true"
          >
            <v-icon>mdi-plus</v-icon>
            <span class="login pa-2">NOVA ATIVIDADE</span>
          </v-btn>
        </template>
        <v-form ref="newActivityForm" v-model="valid" lazy-validation>
          <v-card>
            <v-toolbar color="primary" dark>Nova atividade</v-toolbar>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    v-if="
                      checkProfile(user.profile.id, [
                        profiles.MONITOR_BOLSISTA,
                        profiles.MONITOR_VOLUNTARIO,
                      ])
                    "
                  >
                    <v-text-field
                      v-model="user.fullName"
                      label="Usuário*"
                      required
                      disabled
                      :rules="stringRules"
                    />
                  </v-col>
                  <v-col v-else>
                    <v-select
                      v-model="form.userId"
                      :items="formattedUsers"
                      label="Usuário"
                      required
                      :rules="stringRules"
                      dense
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.title"
                      label="Título*"
                      required
                      :rules="stringRules"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.description"
                      label="Descrição*"
                      required
                      :rules="stringRules"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="form.period"
                          label="Período*"
                          dense
                          required
                          :rules="stringRules"
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker v-model="periodo" range />
                    </v-menu>
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-model="form.hours"
                      label="Horas*"
                      required
                      type="number"
                      :rules="stringRules"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="blue darken-1" text @click="closeModal">
                Fechar
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="edit ? editActivities() : createActivities()"
              >
                Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-row>

    <v-row>
      <v-col cols="12" sm="8" md="3" lg="4" xl="3">
        <v-form ref="activityForm" v-model="validSelect" lazy-validation>
          <v-menu
            v-model="menuSelect"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="formSelect.period"
                label="Período*"
                outlined
                required
                :rules="stringRules"
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker v-model="periodoSelect" range />
          </v-menu>
        </v-form>
      </v-col>
      <v-col cols="12" sm="2" md="3" lg="3" xl="3">
        <v-btn class="bold" color="secondary" x-large @click="getActivities">
          <span class="login pa-2">Consultar</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table class="mt-12" :headers="headers" :items="activities">
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon large v-bind="attrs" v-on="on" @click="openEdit(item)">
              <v-icon class="mr-2"> mdi-pencil </v-icon>
            </v-btn>
          </template>
          <span>Editar atividade</span>
        </v-tooltip>
        <v-tooltip
          v-if="
            !item.approved &&
            checkProfile(user.profile.id, [
              profiles.ADMINISTRADOR,
              profiles.COORDENADOR_DISCENTE,
              profiles.COORDENADOR_DOCENTE,
            ])
          "
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="
                !item.approved &&
                checkProfile(user.profile.id, [
                  profiles.ADMINISTRADOR,
                  profiles.COORDENADOR_DISCENTE,
                  profiles.COORDENADOR_DOCENTE,
                ])
              "
              icon
              large
              v-bind="attrs"
              v-on="on"
              @click="acceptActivity(item)"
            >
              <v-icon class="mr-2"> mdi-check </v-icon>
            </v-btn>
          </template>
          <span>Aprovar atividade</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.approved`]="{ item }">
        <v-chip :color="getColor(item.approved)" dark>
          {{ item.approved ? 'Sim' : 'Não' }}
        </v-chip>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { profiles } from '@/utils/Profiles';

// eslint-disable-next-line import/no-cycle
import {
  getActivityById,
  createActivity,
  editActivity,
  editFullActivity,
} from '@/services/activity';

// eslint-disable-next-line import/no-cycle
import { getUsers } from '@/services/user';

import { stringRules } from '@/utils/Rules';

export default {
  name: 'Activities',
  data: () => ({
    profiles,
    stringRules,
    edit: false,
    valid: false,
    dialog: false,
    menu: false,
    form: {
      title: '',
      description: '',
      date: '',
      period: '',
      hours: 0,
      userId: '',
    },
    formSelect: {
      period: '',
    },
    selectedStudents: [],
    headers: [
      {
        text: 'Código',
        align: 'start',
        filterable: true,
        value: 'id',
        class: 'primary',
      },
      {
        text: 'Título',
        align: 'start',
        filterable: true,
        value: 'title',
        class: 'primary',
      },
      {
        text: 'Descrição',
        align: 'start',
        filterable: true,
        value: 'description',
        class: 'primary',
      },
      {
        text: 'Aprovado',
        align: 'start',
        filterable: true,
        value: 'approved',
        class: 'primary',
      },
      {
        text: 'Horas',
        align: 'start',
        filterable: true,
        value: 'hours',
        class: 'primary',
      },
      {
        text: 'Data Inicial',
        align: 'start',
        filterable: true,
        value: 'startDate',
        class: 'primary',
      },
      {
        text: 'Data Final',
        align: 'start',
        filterable: true,
        value: 'endDate',
        class: 'primary',
      },
      { text: 'Ações', value: 'actions', sortable: false, class: 'primary' },
    ],
    activities: [],
    users: [],
    periodo: [],
    formattedUsers: [],
    periodoSelect: [],
    menuSelect: false,
    validSelect: false,
  }),
  computed: {
    ...mapGetters({ user: 'user/getUser' }),
  },
  watch: {
    periodo() {
      if (!this.periodo || !this.periodo[0] || !this.periodo[1]) return null;

      const [initialYear, initialMonth, initialDay] =
        this.periodo[0].split('-');

      const [finalYear, finalMonth, finalDay] = this.periodo[1].split('-');

      this.form.period = `${initialDay}/${initialMonth}/${initialYear} a ${finalDay}/${finalMonth}/${finalYear}`;
    },
    periodoSelect() {
      if (
        !this.periodoSelect ||
        !this.periodoSelect[0] ||
        !this.periodoSelect[1]
      )
        return null;

      const [initialYear, initialMonth, initialDay] =
        this.periodoSelect[0].split('-');

      const [finalYear, finalMonth, finalDay] =
        this.periodoSelect[1].split('-');

      this.formSelect.period = `${initialDay}/${initialMonth}/${initialYear} a ${finalDay}/${finalMonth}/${finalYear}`;
    },
  },
  mounted() {
    if (
      !this.checkProfile(this.user.profile.id, [
        profiles.MONITOR_BOLSISTA,
        profiles.MONITOR_VOLUNTARIO,
      ])
    )
      this.getUsers();
  },
  methods: {
    ...mapActions('loading', ['showLoading', 'hideLoading']),
    async getUsers() {
      try {
        this.showLoading();
        const { data } = await getUsers({ name: '', profileId: '' });
        this.users = data.rows;

        this.formattedUsers = this.users.map((x) => ({
          text: x.fullName,
          value: x.id,
        }));
      } catch (e) {
        if (this.$root.vtoast) {
          this.$root.vtoast.show({
            message: 'Erro ao buscar usuários.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        }
      } finally {
        this.hideLoading();
      }
    },
    async getActivities() {
      const isValid = this.$refs.activityForm.validate();
      if (isValid) {
        try {
          this.showLoading();
          const { data } = await getActivityById(
            `${
              this.checkProfile(this.user.profile.id, [
                profiles.MONITOR_BOLSISTA,
                profiles.MONITOR_VOLUNTARIO,
              ])
                ? this.user.profile.id
                : `all`
            }?startDate=${this.periodoSelect[0]}&endDate=${
              this.periodoSelect[1]
            }`
          );

          this.activities = data.map((x) => ({
            ...x,
            startDate: this.formatDateToShow(x.startDate),
            endDate: this.formatDateToShow(x.endDate),
          }));
        } catch (e) {
          if (this.$root.vtoast) {
            this.$root.vtoast.show({
              message: 'Erro ao buscar as atividades.',
              top: true,
              right: true,
              show: true,
              color: 'error',
            });
          }
        } finally {
          this.hideLoading();
        }
      }
    },
    async createActivities() {
      try {
        this.showLoading();
        const resultado = await createActivity({
          ...this.form,
          hours: +this.form.hours,
          startDate: this.periodo[0],
          endDate: this.periodo[1],
          userId: this.checkProfile(this.user.profile.id, [
            profiles.MONITOR_BOLSISTA,
            profiles.MONITOR_VOLUNTARIO,
          ])
            ? this.user.profile.id
            : this.form.userId,
        });

        if (resultado && !resultado.success) {
          this.$root.vtoast.show({
            message: 'Erro ao criar a atividade.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        } else {
          this.$root.vtoast.show({
            message: `Atividade ${this.form.title} adicionado com sucesso.`,
            top: true,
            right: true,
            show: true,
            color: 'success',
          });
          this.closeModal();
          this.getActivities();
        }
      } catch (e) {
        this.$root.vtoast.show({
          message: 'Erro ao criar a atividade.',
          top: true,
          right: true,
          show: true,
          color: 'error',
        });
      } finally {
        this.hideLoading();
      }
    },
    openEdit(item) {
      this.dialog = true;
      this.form = {
        ...item,
        period: `${item.startDate} a ${item.endDate}`,
      };
      this.periodo = [
        this.parseDateEs(item.startDate),
        this.parseDateEs(item.endDate),
      ];
      this.edit = true;
    },
    async editActivities() {
      try {
        this.showLoading();
        const resultado = await editActivity({
          ...this.form,
          startDate: this.periodo[0],
          endDate: this.periodo[1],
          hours: +this.form.hours,
          userId: this.checkProfile(this.user.profile.id, [
            profiles.MONITOR_BOLSISTA,
            profiles.MONITOR_VOLUNTARIO,
          ])
            ? this.user.profile.id
            : this.form.userId,
        });

        if (resultado && !resultado.success) {
          this.$root.vtoast.show({
            message: 'Erro ao editar a atividade.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        } else {
          this.$root.vtoast.show({
            message: `Atividade ${this.form.title} editada com sucesso.`,
            top: true,
            right: true,
            show: true,
            color: 'success',
          });
          this.closeModal();
          this.form = {
            title: '',
            description: '',
            date: '',
            address: '',
          };
          this.closeModal();
          this.getActivities();
        }
      } catch (e) {
        this.$root.vtoast.show({
          message: 'Erro ao editar a atividade.',
          top: true,
          right: true,
          show: true,
          color: 'error',
        });
      } finally {
        this.hideLoading();
      }
    },
    closeModal() {
      this.dialog = false;
      this.edit = false;
      this.form = {
        title: '',
        description: '',
        date: '',
        address: '',
      };
    },
    formatDateToShow(timestamp) {
      const date = new Date(timestamp);
      const day = date.getUTCDate().toString().padStart(2, '0');
      const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
      const year = date.getUTCFullYear();

      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    parseDateEs(date) {
      if (!date) return null;

      const [month, day, year] = date.split('/');
      return `${year}-${day.padStart(2, '0')}-${month.padStart(2, '0')}`;
    },
    getColor(value) {
      if (value) return 'green';
      return 'red';
    },
    async acceptActivity(item) {
      try {
        this.showLoading();
        const resultado = await editFullActivity({
          id: item.id,
          approved: true,
          approvedById: this.user.id,
        });

        if (resultado && !resultado.success) {
          this.$root.vtoast.show({
            message: 'Erro ao editar a atividade.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        } else {
          this.$root.vtoast.show({
            message: `Atividade ${this.form.title} aprovada com sucesso.`,
            top: true,
            right: true,
            show: true,
            color: 'success',
          });
          this.getActivities();
        }
      } catch (e) {
        this.$root.vtoast.show({
          message: 'Erro ao editar a atividade.',
          top: true,
          right: true,
          show: true,
          color: 'error',
        });
      } finally {
        this.hideLoading();
      }
    },
    checkProfile(profileId, allowedProfilesIds) {
      if (
        allowedProfilesIds.length > 0 &&
        !allowedProfilesIds.includes(profileId)
      ) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}

*
  >>> .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  background-color: #137cc0;
  color: white;
}

*
  >>> .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th:hover {
  color: white;
}

* >>> .mdi-arrow-up::before {
  color: white;
}
</style>
